/*eslint-disable */
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  signupType: 1,
  infoLoading: true,
  infos: {
    jobs: 0,
    persons: 0,
    companies: 0,
  },
};

export default {
  actions,
  getters,
  mutations,
  state,
};
